import {
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';

export const userRolesInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authenticationService = inject(AuthenticationService);
  const userRoles = authenticationService.getUserRoles();
  
  if (userRoles && userRoles.length > 0) {
    const rolesHeader = userRoles.join(',');
    const modifiedRequest = request.clone({
      setHeaders: {
        'x-user-roles': rolesHeader
      }
    });
    
    return next(modifiedRequest);
  }
  
  return next(request);
};
